import authReducer from './auth/auth.reducer';

const rooReducer = {
  auth: authReducer
};

export default rooReducer;
